interface SessionMeetingSummaryProps {
  summary?: string | null;
  className?: string;
}

export function SessionMeetingSummary({ summary, className = '' }: SessionMeetingSummaryProps) {
  const trimmedSummary = summary?.trim();
  if (!trimmedSummary) return null;

  return (
    <section
      aria-label="会議内容サマリー"
      className={`min-w-0 rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm ${className}`}
    >
      <h2 className="text-xs font-semibold text-gray-500">サマリー</h2>
      <p className="mt-1 whitespace-pre-wrap break-words text-sm leading-6 text-gray-700">
        {trimmedSummary}
      </p>
    </section>
  );
}
